import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next'

const 
ExamReviewSection = (props) => {
  const { qData, selectedOptions, isSaveQ, handleReview, handleEndReview, reviewAfterMarkedStack } = props;

  const { t }  = useTranslation();
  useEffect(() => {
    isSaveQ ?(
       
        toast.success('Questions saved', { autoClose: 3000 })
        ):''

  }, [isSaveQ])

  
  return (
    <React.Fragment>
  

        <section className="section mt-4 bg-white position-relative exam-page-content exam-review-content">
            <div className="container-fluid">
            <div className="row ">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header align-items-center d-flex">
                            <h4 className="card-title mb-0 flex-grow-1">{t('Exam Screen For Review')}</h4>
                        </div>

             
           
                        <div className="card-body">
                            <p className="text-muted exam-review-intro">{t('Please check answers')} <code>{t('before end review')}</code></p>
                            <div className="live-preview">
                                <div className="row gy-4">
                                {qData
                        ? qData.map((item, i) => {
                            return (

                                    <div className="col-6 col-md-4 col-xl-2" key={item.id}>
                                        <div className="card exam-review-card ribbon-box border shadow-none mb-lg-0 right">
                                            <div className="card-body exam-review-card-body">
                                            {selectedOptions[i] && selectedOptions[i].correctAns != '' ? (
                                                <span className="ribbon-three ribbon-three-success"><span>{t('Answered')}</span></span>
                                                ) : (
                                                    <span className="ribbon-three ribbon-three-danger"><span>{t('Pending')}</span></span>
                                                    )}
                                                <div className="exam-review-card-content">
                                                    <div className="form-check form-check-outline form-check-success mb-0">
                                                        <input className="form-check-input btn-checkbox text-white" type="checkbox"
                                                         value=""
                                                        checked={reviewAfterMarkedStack.includes(i)}
                                                         />
                                                        <label className="form-check-label exam-review-question-label" htmlFor="formCheck13">{t('Question')} {i + 1}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                         )
                                        })
                                      : ''}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

            </div>
        </section>
        <footer className="footer py-3 exam-footer exam-review-footer">
            <div className="container-fluid">
                <div className="d-flex flex-wrap gap-3 justify-content-end exam-review-actions">
                        <button type="button" className="btn btn-primary btn-sm bg-gradient waves-effect waves-light" onClick={() => handleReview(1)}>{t('Review All')} </button>
                        <button type="button" className="btn btn-primary btn-sm bg-gradient waves-effect waves-light" onClick={() => handleReview(2)}>{t('Review Unanswered')} </button>
                        <button type="button" className="btn btn-primary btn-sm bg-gradient waves-effect waves-light" onClick={() => handleReview(3)}>{t('Review Checked Only')} </button>
                        <button type="button"  className="btn btn-primary btn-sm bg-gradient waves-effect waves-light" onClick={() => handleEndReview()}>{t('End Review')} </button>
                </div>
            </div>
        </footer>

<ToastContainer closeButton={false} limit={1} />
</React.Fragment>
  )
}

export default ExamReviewSection